import {
    FLAME,
    FLAME_BG,
    FOCUS,
    INK,
    JAVI_IMAGE,
    MUTED,
    PRIMARY_CTA_LABEL,
    SAMUEL_IMAGE,
    SURFACE_DARK,
    scrollToId,
} from './asesoriaTokens'

export function AsesoriaHeroSection() {
    return (
        <section className='mx-auto flex max-w-[1200px] flex-col items-center gap-10 px-6 pb-16 pt-28 lg:flex-row lg:items-center lg:gap-14 lg:pb-[72px] lg:pt-32'>
            <div className='flex w-full min-w-0 flex-1 flex-col gap-7 lg:basis-[520px]'>
                <div className={`text-xs font-semibold uppercase tracking-[0.14em] ${FLAME}`}>
                    Asesoría Tipi · Hostelería rentable
                </div>
                <h1 className={`m-0 text-[40px] font-extrabold leading-none tracking-[-0.035em] md:text-[64px] ${INK}`}>
                    Quiero olvidarme de la gestión de mi negocio. Yo trabajo por pasión.
                </h1>
                <p className={`m-0 max-w-[620px] text-xl font-semibold ${INK}`}>
                    Somos tu contable y tu asesor de hostelería: preparamos todas tus facturas y ventas, vigilamos tus
                    números cada semana y te damos recomendaciones reales del sector. Tú cocinas.
                </p>
                <p className={`m-0 max-w-[620px] text-xl ${MUTED}`}>
                    Fuimos dos cocineros que montamos nuestros negocios y nos arrepentimos de volvernos empresarios y
                    alejarnos de nuestra pasión. Ahora te ayudamos a que a ti no te pase.
                </p>
                <div className='flex flex-wrap items-center gap-3.5'>
                    <button
                        type='button'
                        onClick={() => scrollToId('plaza')}
                        className={`inline-flex min-h-[52px] items-center rounded-full px-7 text-[17px] font-bold text-white shadow-[0_4px_14px_rgba(209,61,26,0.4)] transition-colors ${FLAME_BG} ${FOCUS}`}
                    >
                        {PRIMARY_CTA_LABEL}
                    </button>
                </div>
            </div>
            <div className='flex w-full max-w-[480px] flex-col gap-4 lg:max-w-none lg:flex-none lg:basis-[400px]'>
                <div className='grid grid-cols-2 gap-3'>
                    <figure className='m-0 flex flex-col gap-2'>
                        <img
                            src={SAMUEL_IMAGE}
                            alt='Samuel Carrillo'
                            className='block aspect-[4/5] w-full rounded-[24px] object-cover object-[center_20%]'
                        />
                        <figcaption className='text-[13px] text-[#8A7F6F]'>
                            <span className='font-semibold text-[#17130E]'>Samuel Carrillo</span>
                            <span className='mt-0.5 block text-[12px]'>
                                + de 20M€ gestionados en hostelería antes de los 30 años
                            </span>
                        </figcaption>
                    </figure>
                    <figure className='m-0 flex flex-col gap-2'>
                        <img
                            src={JAVI_IMAGE}
                            alt='Javier Porras'
                            className='block aspect-[4/5] w-full rounded-[24px] object-cover object-[center_18%]'
                        />
                        <figcaption className='text-[13px] text-[#8A7F6F]'>
                            <span className='font-semibold text-[#17130E]'>Javier Porras</span>
                            <span className='mt-0.5 block text-[12px]'>
                                4 negocios gestionados · 4 traspasados con beneficios
                            </span>
                        </figcaption>
                    </figure>
                </div>
                <div className={`flex flex-col gap-2 rounded-[20px] ${SURFACE_DARK} px-[22px] py-5 text-[#F5EEE4]`}>
                    <span className='text-[18px] font-bold leading-snug'>Solo cogemos 1 cliente al mes</span>
                    <span className='text-sm text-[#A89F90]'>
                        Priorizamos un servicio excelente. Si este mes ya está cogido, te avisamos para el siguiente.
                    </span>
                </div>
            </div>
        </section>
    )
}
